
<div class="loading-shade" *ngIf="isLoading ">
	<mat-spinner diameter="80" *ngIf="isLoading"></mat-spinner>
</div>

	<form [formGroup]="createSchoolDistrictForm" class="formCreateSchoolDistrict">
		<div *ngIf="!isCreated">
		<span class="forceFloatRight"><button mat-icon-button color="primary" (click)="closeRecord()">
				<span class="centercloseBtn" ><mat-icon>close</mat-icon></span> 
			</button></span>

		<mat-card-title><span style="padding-left:18px;padding-top:5px;font-size:larger;">Create New School District</span></mat-card-title>
		<div class="row">
			<div class="child-1 col-6 halfWidth">
				<mat-card appearance="outlined" class="cardLocation">
					<mat-card-content>
						<h2>School District Location</h2>

						<div class="form-group">
							<div class="row">
								<region-dropdown id="myRegion" (eventEmitterRegioncode)="regionEventEmitter($event)"
									[formControl]="schoolDistrictRegionFC" [reset]="resetField" 
									[isMultiple]="false" *ngIf="!isLoading" [allowAllRegions]="true"
									 #child2
									[customLabel]="customRegionLabel" [disabled]="isUneditable" 
									[errorStateMatcher]="matcher" matInput (required)="true"></region-dropdown>
							</div>
							<div class="row">
								<county-dropdown id="myCounty1" [reset]="resetField" (eventEmitterCounty)="countiesSelected($event)"
									[formControl]="schoolDistrictCountyFC"  
									[isMultiple]="false" *ngIf="!isLoading" #child3
									[customLabel]="customCountyLabel" 
									[disabled]="isUneditable"
									[errorStateMatcher]="matcher"  matInput (required)="true"></county-dropdown>						
							</div>
						</div>
					</mat-card-content>
				</mat-card>
			</div>

			<div class="child-2 col-6 halfWidth"> 
			<mat-card appearance="outlined">
				<mat-card-content>
					<div>
						<h2>School District</h2>
						<div class="row">
							<mat-form-field appearance="fill" tabindex="2">
								<mat-label>School District Name *</mat-label>
								<input id="schoolDistrictName" name="schoolDistrictName" ngDefaultControl [formControl]="schoolDistrictNameFC" type="text"
									matInput maxlength="100" (keyup)="onKeyUp($event)"
									class="form-control field-full-width" (click)="fnDeactivateInitialLoad()"
									placeholder="School District Name" [errorStateMatcher]="matcher"
									[(ngModel)]="schoolDistrictName">
							</mat-form-field>
						</div>
						<div class="row">
							<mat-form-field appearance="fill" tabindex="3">
								<mat-label>School District Code *</mat-label>
								<input id="schoolDistrictCode" 
									name="schoolDistrictCode" 
									ngDefaultControl 
									[formControl]="schoolDistrictCodeFC" 
									type="tel"
									matInput class="form-control" minlenght="5" 
									maxlength="5" (keyup)="onKeyUp($event)"
									(keydown)="onKeyDown($event)"
									(click)="fnDeactivateInitialLoad()" 
									placeholder="School District Code (XXXXX)"
									[errorStateMatcher]="matcher" 
									[(ngModel)]="schoolDistrictCode">
							</mat-form-field>
							<!-- pattern="[0-9]" 	formControlName="schoolDistrictCode" <-- cant use both! -->
							<mat-error class="moveErrorsUp"
								*ngIf="!isInitialLoad && schoolDistrictCodeFC.hasError('text')">
								Please enter a valid district code
							</mat-error>
							<mat-error class="moveErrorsUp"
								*ngIf="!isInitialLoad && schoolDistrictCodeFC.hasError('minlength')">
								School District Code is 5 characters long.
							</mat-error>		
						</div>
						<div class="row">
							<mat-form-field appearance="fill" tabindex="4">
								<mat-label>School District NCES *</mat-label>
								<input 
									id="schoolDistrictNCES" 
									name="schoolDistrictNCES" 
									ngDefaultControl
									[formControl]="schoolDistrictNcesFC" 
									type="tel"
									matInput 
									class="form-control" 
									minlength="7" maxlength="7" 
									(keyup)="onKeyUp($event)"
									(keydown)="onKeyDown($event)"
									(click)="fnDeactivateInitialLoad()" 
									placeholder="NCES"
									[errorStateMatcher]="matcher" 
									[(ngModel)]="schoolDistrictNCES"
									>
								<!--	formControlName="schoolDistrictNcesFC" 
										id="schoolDistrictNCES"  pattern="[0-9]" #child4 [readonly]="isUneditable" 	value="{{ncesCode}}" [(ngModel)]="ncesCode"  (keyup)="fnCheckNCESDistrictCode($event)" -->

									<!--<ng-container *ngIf="ncesValid && !ncesChecking && !ncesChecked">              
										<button  class="btnCheckGreen" style="float:right;" mat-raised-button>
											<mat-icon matSuffix>check_circle</mat-icon>
										</button>  
									</ng-container>
								-->
						
					

								<!-- formControlName="schoolDistrictNCES"  -->
								<span class="checkCodeButton">
									<ng-container *ngIf="ncesChecking"> 
										<!-- !ncesValid   && !ncesChecked including if sc is blank or invalid-->
										<button class="btnCheckRed" mat-raised-button [disabled]="isUneditable"
											(click)="btnClick.emit($event)" style="transform: translateX(11px);">
											<i class="fa fa-refresh fa-spin fa-fw"></i>
										</button>
									</ng-container>
									
									<!-- <ng-container *ngIf="!ncesValid && !ncesChecking && !ncesChecked">
										<button class="btnCheckRed" mat-raised-button [disabled]="isUneditable"
											(click)="btnClick.emit($event)">
											<i class="fa fa-check fa-fw" style="opacity:0.3"></i>
											<mat-icon matSuffix>highlight_off</mat-icon>
										</button>
									</ng-container>
									<ng-container *ngIf="!ncesValid && !ncesChecking  && ncesChecked"> 
										<button class="btnCheckRed" mat-raised-button [disabled]="isUneditable"
											(click)="btnClick.emit($event)">
											<i class="fa fa-check fa-fw"></i>
											<mat-icon matSuffix>highlight_off</mat-icon>
										</button>
									</ng-container>
								-->										

									<ng-container *ngIf="!ncesValid && !ncesChecking  && !ncesChecked">
										<button class="btnCheckRed" mat-raised-button [disabled]="isUneditable"
											(click)="btnClick.emit($event)">
											<mat-icon matSuffix>highlight_off</mat-icon>
										</button>
									</ng-container>
									<ng-container *ngIf="ncesValid && !ncesChecking">
										<button class="btnCheckGreen" mat-raised-button [disabled]="isUneditable"
											(click)="btnClick.emit($event)">
											<mat-icon matSuffix>check_circle</mat-icon>
										</button>
									</ng-container>
								</span>
							</mat-form-field>
							<!-- <mat-error class="moveErrorsUp" *ngIf="!isInitialLoad && schoolDistrictNcesFC.hasError('text')">
								Please enter a valid district nces
							</mat-error>-->					
							<!-- <mat-error class="moveErrorsUp"
								*ngIf="!isInitialLoad && schoolDistrictNcesFC?.get('schoolDistrictNCES')?.hasError('minlength')">
								School District NCES is 7 characters long.
							</mat-error>-->
							<!--
							<div *ngIf="!isUneditable">
								<mat-error *ngIf="selected.hasError('required')">Please enter a valid School
									District Code.
								</mat-error>
							</div>
							-->
						</div>
					</div>
				</mat-card-content>
			</mat-card>
			</div>

		</div>

		<p>&nbsp;</p><!-- 		* Required fields		-->
		<hr>
		<div class="row">
			<div>
				<mat-action-row>

					<ng-container>
						<span styles="position:absolute; background-color:blue;">
							<button type="button" (click)="fnSaveCreate();" mat-raised-button color="primary"
								(onSubmitErrorEvent)="catchSubmitError($event)"
								matTooltip="Save school district" [disabled]="disableTabButton(1)">Create</button>&nbsp;&nbsp;
							<mat-icon *ngIf="isLoading && !msg.SUCCESS">
								<mat-spinner *ngIf="isLoading" diameter="20"> </mat-spinner>
							</mat-icon>
							<mat-icon *ngIf="msg.SUCCESS">
								done
							</mat-icon>
							<button mat-raised-button (click)="fnReset()" matTooltip="Reset create fields">Reset</button>
						</span>
					</ng-container>
				</mat-action-row>
			</div>
			<div class="errorMsg">
				<textarea readonly="true" class="errorMsgCtl" disabled id="txtErrorMsg" cols="57">{{myError}}</textarea>
			</div>
			<div>
				<app-msg [msg]="userIdChangedMsg" *ngIf="userIdChangedMsg.MSG"></app-msg>
				<app-msg [msg]="msg"></app-msg>
			</div>
		</div>
</div>
<div *ngIf="isCreated" style="overflow:hidden;overflow-x:hidden;">
	<form>
		<mat-card-title><span style="padding-left:18px;font-size:larger;">Create New School District</span></mat-card-title>
				<span class="floatRight" style="margin-right:30px;">
					<span class="forceHigh">
						<button class="close-button" mat-mini-fab [mat-dialog-close]="true" *ngIf="!isLoading">
							<mat-icon>close</mat-icon>
						</button>
					</span>
				</span>
				<div class="row">
					<div class="col-xs-6 col-sm-6 col-md-6 col-lg-6col-xl-6" style="padding-left:20px;" >
					<mat-card appearance="outlined">
						<mat-card-content>
							<span class="greenBold">
								<h2>Successfully created new school district</h2>
							</span>
							<p>&nbsp;</p>
							<button mat-raised-button matTooltip="Create new school district" (click)="fnCreateAnother()"
								class="btnRaise">
								<ng-container *ngIf="!bCancelCreate">
									<mat-icon class="iconDisplay">edit</mat-icon>
								</ng-container>&nbsp;Create another school district
							</button>
							<p>&nbsp;</p>
							<p>&nbsp;</p>				
						</mat-card-content>
					</mat-card>
				</div>
		</div> 
	</form>
</div>
</form>
